import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ThemeProvider } from 'styled-components';

import { CalmTheme, Checkbox, Colors } from '@calm-web/design-system';

import messages from './messages';
import { Wrapper } from './styles';

export const ZEN_MODE_KEY = 'isZenModeEnabled';

const ZenModeSelector = () => {
	const { formatMessage } = useIntl();
	const [isChecked, setIsChecked] = useState<boolean | null>(null);

	const onChange = () => {
		const nextIsChecked = !isChecked;
		localStorage.setItem(ZEN_MODE_KEY, nextIsChecked.toString());
		setIsChecked(nextIsChecked);
	};

	useEffect(() => {
		// TODO: refactor this code to follow best practices
		// eslint-disable-next-line react-hooks/set-state-in-effect
		setIsChecked(localStorage.getItem(ZEN_MODE_KEY) === 'true');
	}, []);

	return (
		<Wrapper>
			{isChecked !== null && (
				<ThemeProvider
					theme={{
						palette: {
							...CalmTheme.palette,
							checkboxSelectedBg: Colors.blue2,
							checkboxSelectedBorder: Colors.blue2,
							focusRingDark: Colors.white,
						},
					}}
				>
					<Checkbox name="zen-mode-toggle" value="zen-mode-toggle" onChange={onChange} checked={isChecked}>
						{formatMessage(messages.zenModeSelector)}
					</Checkbox>
				</ThemeProvider>
			)}
		</Wrapper>
	);
};

export default ZenModeSelector;
